
import React from 'react';
import { X } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  maxWidth?: string;
}

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, maxWidth = 'max-w-4xl' }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-200">
      <div className={`bg-white border-4 border-slate-900 shadow-[12px_12px_0px_0px_rgba(15,23,42,1)] w-full ${maxWidth} flex flex-col max-h-[90vh] animate-in zoom-in-95 duration-200`}>
        <div className="flex items-center justify-between p-6 border-b-4 border-slate-900 bg-[#FFDB00]">
          <h3 className="text-xl font-black text-slate-900 uppercase tracking-tighter">{title}</h3>
          <button 
            onClick={onClose}
            className="p-2 bg-white border-4 border-slate-900 hover:bg-rose-500 hover:text-white transition-all shadow-[4px_4px_0px_0px_rgba(15,23,42,1)] active:translate-x-[1px] active:translate-y-[1px] active:shadow-none"
          >
            <X size={20} />
          </button>
        </div>
        <div className="flex-1 overflow-auto p-6">
          {children}
        </div>
      </div>
    </div>
  );
};
